import type { IAgentTool } from '../IAgentTool';
import { normalizeField } from '../../../assistant/utils/conditionEvaluation';

export const colorByTool: IAgentTool = {
  name: 'color_by',
  description: 'Color nodes by a categorical field (e.g., department).',
  parameters: {
    type: 'object',
    properties: {
      field: { type: 'string', description: 'Field to color by' },
    },
    required: ['field'],
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(params, context) {
    const field = normalizeField(String(params.field ?? '').trim());
    if (!field) {
      return { success: false, summary: 'Missing field for color by.' };
    }

    const ruleId = context.stores.viewRules.addViewRule('colorBy', { field });
    return {
      success: true,
      summary: `Colored nodes by ${field}.`,
      createdResourceIds: ruleId ? [ruleId] : [],
    };
  },
};
